import {ITheme} from 'contexts/ThemeContext';
import {StyleSheet, ViewStyle} from 'react-native';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  maxSize,
  minSize,
} from 'rn-responsive-styles';

export const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 0,
    height: 2,
  },
  shadowOpacity: 0.13,
  shadowRadius: 2.62,

  elevation: 4,
};

const shadowOverflow: ViewStyle = {
  overflow: 'hidden',
};

export default (props: ITheme) =>
  CreateResponsiveStyle(
    {
      listTitleText: {
        marginVertical: 25,
        marginLeft: 15,
        fontSize: 20,
        color: props.colors.black,
        ...props.typography.mulishBold,
      },

      sectionHeader: {
        marginLeft: 16,
        fontSize: 17,
        color: props.colors.black,
        marginBottom: 10,
        ...props.typography.mulishBold,
      },

      sectionFooter: {
        borderBottomColor: props.colors.cornflowerBlueWithOpacity(0.13),
        borderBottomWidth: 1,
        width: '90%',
        alignSelf: 'center',
        paddingTop: 24,
        marginBottom: 30,
      },

      shadowOverflowFirstItem: {
        ...shadowOverflow,
        paddingTop: 5,
      },
      shadowOverflowLastItem: {
        ...shadowOverflow,
        paddingBottom: 5,
      },
      shadowOverflowRegularItem: {
        ...shadowOverflow,
      },
      shadowOverflowSingleItem: {
        ...shadowOverflow,
        paddingBottom: 5,
      },

      firstSectionItemWrapper: {
        backgroundColor: props.colors.white,
        marginHorizontal: 16,
        borderRadius: 10,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        ...shadow,
      },

      oneSectionItemWrapper: {
        backgroundColor: props.colors.white,
        marginHorizontal: 16,
        borderRadius: 10,
        ...shadow,
      },

      sectionItemWrapper: {
        backgroundColor: props.colors.white,
        marginHorizontal: 16,
        borderRadius: 10,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        ...shadow,
      },
      lastSectionItemWrapper: {
        backgroundColor: props.colors.white,
        marginHorizontal: 16,
        borderRadius: 10,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        ...shadow,
      },

      sectionItem: {
        marginHorizontal: 16,
        marginTop: 16,
        borderBottomColor: props.colors.cornflowerBlueWithOpacity(0.13),
        borderBottomWidth: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
      },

      lastSectionItem: {
        marginHorizontal: 16,
        marginTop: 16,
        flexDirection: 'row',
        justifyContent: 'space-between',
      },

      lessonTextStyle: {
        color: props.colors.black,
        ...props.typography.interMedium,
        fontSize: 17,
      },
      textStyle: {
        color: props.colors.black,
        fontSize: 17,
        marginVertical: 6,
        ...props.typography.interRegular,
      },
      fontSize15: {
        fontSize: 15,
      },
      timeStyle: {
        fontSize: 15,
        color: props.colors.black,
        ...props.typography.interMedium,
      },

      buttonTextStyle: {
        color: props.colors.white,
        fontSize: 16,
        ...props.typography.mulishMedium,
      },
      createButtonTextStyle: {
        color: props.colors.cornflowerBlue,
        fontSize: 16,
        ...props.typography.interMedium,
      },
      pillButtonContainer: {
        marginBottom: 25,
      },
      sectionListView: {},
      sectionList: {
        flex: 1,
        marginTop: 1,
      },
    },
    {
      [minSize(DEVICE_SIZES.SMALL_DEVICE)]: {
        sectionListView: {
          flex: 1,
          paddingHorizontal: 10,
        },
      },
      [maxSize(DEVICE_SIZES.EXTRA_SMALL_DEVICE)]: {
        sectionListView: {
          flex: 1,
        },
      },
    },
  )();
